import { Component, EventEmitter, Input } from '@angular/core';
import { ColumnDefinition, CustomCellComponent } from '@vendasta/va-filter2-table';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Activity } from '@vendasta/automata';

interface ActivityRow {
  activity: Activity;
}

@Component({
  template: ` <span>{{ element?.activity?.entityId }}</span> `,
  imports: [CommonModule, TranslateModule],
})
export class NoEntityCellComponent implements CustomCellComponent<ActivityRow> {
  @Input() columnDefinition: ColumnDefinition;
  @Input() translateService: TranslateService;
  @Input() element: ActivityRow;
  @Input() eventEmitter: EventEmitter<any>;

  ///TODO: this could get the value from the CellValueService like the DateCellComponent
}
